var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14594 25.2554C11.4755 25.2554 14.1747 20.6561 14.1747 14.9825C14.1747 9.30894 11.4755 4.70959 8.14594 4.70959C4.81635 4.70959 2.11719 9.30894 2.11719 14.9825C2.11719 20.6561 4.81635 25.2554 8.14594 25.2554Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 25.2554C25.1865 25.2554 27.8856 20.6561 27.8856 14.9825C27.8856 9.30894 25.1865 4.70959 21.8569 4.70959C18.5273 4.70959 15.8281 9.30894 15.8281 14.9825C15.8281 20.6561 18.5273 25.2554 21.8569 25.2554Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 25.2554C25.1865 25.2554 27.8856 20.6561 27.8856 14.9825C27.8856 9.30894 25.1865 4.70959 21.8569 4.70959C18.5273 4.70959 15.8281 9.30894 15.8281 14.9825C15.8281 20.6561 18.5273 25.2554 21.8569 25.2554Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1727 19.1017C21.0199 19.1017 22.5173 17.6043 22.5173 15.7571C22.5173 13.9099 21.0199 12.4125 19.1727 12.4125C17.3255 12.4125 15.8281 13.9099 15.8281 15.7571C15.8281 17.6043 17.3255 19.1017 19.1727 19.1017Z",
    fill: "#A57939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14594 25.2554C11.4755 25.2554 14.1747 20.6561 14.1747 14.9825C14.1747 9.30894 11.4755 4.70959 8.14594 4.70959C4.81635 4.70959 2.11719 9.30894 2.11719 14.9825C2.11719 20.6561 4.81635 25.2554 8.14594 25.2554Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46177 19.1017C7.30893 19.1017 8.80635 17.6043 8.80635 15.7571C8.80635 13.9099 7.30893 12.4125 5.46177 12.4125C3.61461 12.4125 2.11719 13.9099 2.11719 15.7571C2.11719 17.6043 3.61461 19.1017 5.46177 19.1017Z",
    fill: "#A57939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14594 25.2554C11.4755 25.2554 14.1747 20.6561 14.1747 14.9825C14.1747 9.30894 11.4755 4.70959 8.14594 4.70959C4.81635 4.70959 2.11719 9.30894 2.11719 14.9825C2.11719 20.6561 4.81635 25.2554 8.14594 25.2554Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 25.2554C25.1865 25.2554 27.8856 20.6561 27.8856 14.9825C27.8856 9.30894 25.1865 4.70959 21.8569 4.70959C18.5273 4.70959 15.8281 9.30894 15.8281 14.9825C15.8281 20.6561 18.5273 25.2554 21.8569 25.2554Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46271 17.2667C6.29643 17.2667 6.97229 16.5908 6.97229 15.7571C6.97229 14.9234 6.29643 14.2475 5.46271 14.2475C4.62899 14.2475 3.95312 14.9234 3.95312 15.7571C3.95312 16.5908 4.62899 17.2667 5.46271 17.2667Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1736 17.2667C20.0074 17.2667 20.6832 16.5908 20.6832 15.7571C20.6832 14.9234 20.0074 14.2475 19.1736 14.2475C18.3399 14.2475 17.6641 14.9234 17.6641 15.7571C17.6641 16.5908 18.3399 17.2667 19.1736 17.2667Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46271 17.2667C6.29643 17.2667 6.97229 16.5908 6.97229 15.7571C6.97229 14.9234 6.29643 14.2475 5.46271 14.2475C4.62899 14.2475 3.95312 14.9234 3.95312 15.7571C3.95312 16.5908 4.62899 17.2667 5.46271 17.2667Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46177 19.1017C7.30893 19.1017 8.80635 17.6043 8.80635 15.7571C8.80635 13.9099 7.30893 12.4125 5.46177 12.4125C3.61461 12.4125 2.11719 13.9099 2.11719 15.7571C2.11719 17.6043 3.61461 19.1017 5.46177 19.1017Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1736 17.2667C20.0074 17.2667 20.6832 16.5908 20.6832 15.7571C20.6832 14.9234 20.0074 14.2475 19.1736 14.2475C18.3399 14.2475 17.6641 14.9234 17.6641 15.7571C17.6641 16.5908 18.3399 17.2667 19.1736 17.2667Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1727 19.1017C20.0199 19.1017 21.5173 17.6043 21.5173 15.7571C21.5173 13.9099 20.0199 12.4125 18.1727 12.4125C16.3255 12.4125 14.8281 13.9099 14.8281 15.7571C14.8281 17.6043 16.3255 19.1017 18.1727 19.1017Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditPortfolioIcon);
export default __webpack_public_path__ + "static/media/audit-portfolio-icon.1c82fca42fc4bfda9bd9e4c2c2988871.svg";
export { ForwardRef as ReactComponent };